<div id="gc-dg-success">
    <h1>Success</h1>
    <p>Your plans were successfully created</p>
</div>
